// src/main.jsx
import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css'; // Import Tailwind CSS
import './styles/styles.css'; // Import custom CSS
import App from './App';
import { registerServiceWorker } from './utils/registerServiceWorker';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

registerServiceWorker();
